<template>
  <div id="root" class="root">
    <el-container>
      <el-header>
        <page-header />
      </el-header>
      <el-main class="el-main-pkg">
        <div class="main-area el-width-center">
          <el-card data-card-main>
            <el-menu
              class="menu"
              mode="horizontal"
              :default-active="currentLink"
              :router="true"
            >
              <el-menu-item
                v-for="(item, index) in tabs"
                :key="item.name"
                :index="item.link"
              >
                {{ item.label }}
              </el-menu-item>
            </el-menu>
            <router-view />
          </el-card>
        </div>
      </el-main>
      <el-footer>
        <page-footer />
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import "reset-css";
import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import PageHeader from "@/components/PageHeader";
import PageFooter from "@/components/PageFooter";

Vue.use(ElementUI);
Vue.component("PageHeader", PageHeader);
Vue.component("PageFooter", PageFooter);

export default {
  name: "Root",
  data() {
    return {
      tabs: [
        { name: "app", label: "应用列表", link: "/app.html" },
        { name: "software", label: "软件下载", link: "/software.html" },
        { name: "material", label: "素材分享", link: "/material.html" },
        { name: "share", label: "资料共享", link: "/share.html" },
        { name: "tools", label: "工具箱", link: "/tools.html" },
      ],
      currentLink: "/app.html",
    };
  },
  methods: {},
  watch: {
    $route: {
      handler() {
        this.currentLink = this.tabs
          .map((item) => item.link)
          .includes(this.$route.path)
          ? this.$route.path
          : "/app.html";
      },
      deep: true,
    },
  },
  mounted() {
    // setInterval(()=>{
    //   console.log(this.$route.path);
    // },30);
    // this.$nextTick(()=>{
    //   console.log(this.tabs.map(item => item.link).includes(this.$route.path),this.$route)
    //   this.currentLink = this.tabs.map(item => item.link).includes(this.$route.path) ? this.$route.path : '/app.html'
    // })
    // this.$nextTick(()=>{
    //   console.log(this.$router.currentRoute.path,'---');
    //   const find = this.tabs.find(item => item.link === this.$router.currentRoute.path);
    //   this.currentLink = find ? find.link : this.tabs[0] ? this.tabs[0].link : '' ;
    // })
  },
};
</script>

<style scoped>
.root {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100%;
  width: 100%;
  /*
  background-image: linear-gradient(-225deg, #FFFEFF 0%, #D7FFFE 100%);
  background-image: radial-gradient(73% 147%, #EADFDF 59%, #ECE2DF 100%), radial-gradient(91% 146%, rgba(255,255,255,0.50) 47%, rgba(0,0,0,0.50) 100%); background-blend-mode: screen;
  */
}
.main-area {
  padding: 15px 0;
}
.card-main-area {
  background-color: red;
}
.card-main-area .el-card__body {
  padding: 0;
}
.menu a,
.el-menu-item a {
  text-decoration: none;
}
</style>

<style>
.el-container {
  height: 100%;
}
.el-header {
  padding: 0 !important;
  /*background-image: linear-gradient(4deg, #fcfaff 45.17%, #e5eff7 95.21%);*/
  background-repeat: no-repeat;
  background-size: 100% 70px;
}
.el-main {
  margin: 0;
  padding: 0;
  overflow: visible !important;
}
.el-footer {
  /*background-image: linear-gradient(4deg, #ffffff 45.17%, #f4f1f6 95.21%);*/
  opacity: 1;
}
[data-card-main] > div {
  padding: 0;
}
.el-main-pkg {
  overflow: visible !important;
}
</style>



// WEBPACK FOOTER //
// src/Root.vue